import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import {
  getExperienceBasicInfo,
  getVariationNameById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderModeToggled } from "@src/utils/mixpanel";

export interface TrackModeToggledPayload {
  toggledTo: "select" | "navigate" | "desktop" | "mobile";
}

export const trackModeToggled = createAsyncThunk<void, TrackModeToggledPayload>(
  "experienceBuilder/tracking/modeToggled",
  (payload, { getState }) => {
    const experienceInfo = getExperienceBasicInfo(getState());
    if (!experienceInfo) return;

    const { experienceId, experienceName, experienceType } = experienceInfo;
    const variationId =
      experienceBuilderSlice.selectors.getVariationId(getState());
    const getVariationName = getVariationNameById(getState());
    const variationName = getVariationName(variationId);
    const mods = getVariationMods(getState());

    mpVisualBuilderModeToggled({
      experienceId,
      experienceName,
      experienceType,
      groupName: variationName,
      modCount: mods.length,
      toggledTo: payload.toggledTo,
    });
  }
);
